module.exports = __webpack_public_path__ + "static/media/ladder-700px.ced07249.png";